export class PauseSettingDao {
  constructor(pause: string, beginn: string, ende: string) {
    this.pause = pause;
    this.beginn = beginn;
    this.ende = ende;
  }

  pause: string;
  beginn: string;
  ende: string;
}
